import favoriteRepository from '@/api/v2/model/favorite'

export default {
    index(context, { projectId }) {
        return new Promise((resolve, reject) => {
            favoriteRepository
                .readFavorites(projectId)
                .then(({ data }) => {
                    context.commit('setFavorites', data.data)
                    resolve(data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
